<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import avatarPng from 'assets/image/avatar@2x.png';
import { RouterService } from '@core/services/router.service';
import { UserService } from '@core/services/user.service';

const userService = useService(UserService);
const routerService = useService(RouterService);

const handleLogin = async () => {
  userService.showLoginModal();
};

const handleLogout = async () => {
  userService.reset();
  routerService.reload();
};
</script>
<template>
  <div v-track:newoj_navi_portrait_show class="ml-3">
    <a-dropdown
      v-if="userService.isLogin()"
      placement="bottomRight"
      class="flex items-center"
      trigger="click"
    >
      <div class="cursor-pointer">
        <a-avatar
          v-track:newoj_navi_portrait_click.click
          :size="34"
          class="!border-colorFillSecondary"
          :src="userService.user.avatar || avatarPng"
          alt="avatar"
        />
      </div>

      <template #overlay>
        <a-menu class="w-[112px]">
          <template v-if="userService.isAdmin()">
            <a-menu-item class="h-8 leading-8">
              <NuxtLink
                to="/admin"
                class="flex items-center rounded-md text-left"
              >
                <img
                  class="h-4 w-4"
                  src="@core/assets/image/icon/settings/monitor-cog.svg"
                  alt="platform"
                />
                <span class="ml-2 text-title">后台管理</span>
              </NuxtLink>
            </a-menu-item>
          </template>
          <a-menu-item class="h-8 leading-8">
            <NuxtLink
              to="/oj/home"
              class="flex items-center rounded-md text-left"
            >
              <img
                class="h-4 w-4"
                src="@core/assets/image/icon/settings/user-round.svg"
                alt="user"
              />
              <span class="ml-2 text-title">我的主页</span>
            </NuxtLink>
          </a-menu-item>
          <a-menu-item class="h-8 leading-8">
            <NuxtLink
              to="/oj/profile"
              class="flex items-center rounded-md text-left"
            >
              <img
                class="h-4 w-4"
                src="@core/assets/image/icon/settings/file-bar-chart.svg"
                alt="profile"
              />
              <span class="ml-2 text-title">个人信息</span>
            </NuxtLink>
          </a-menu-item>
          <a-menu-item class="h-8 leading-8">
            <NuxtLink
              to="/oj/home/group/records"
              class="flex items-center rounded-md text-left"
            >
              <img
                class="h-4 w-4"
                src="@core/assets/image/icon/settings/users.svg"
                alt="profile"
              />
              <span class="ml-2 text-title">小组申请</span>
            </NuxtLink>
          </a-menu-item>
          <a-menu-item class="h-8 leading-8">
            <a
              href="javascript:;"
              class="flex items-center rounded-md text-left"
              @click="handleLogout"
            >
              <img
                class="h-4 w-4"
                src="@core/assets/image/icon/settings/square-arrow-up.svg"
                alt="logout"
              />
              <span class="ml-2 text-title">退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>

    <a-button
      v-else
      class="rounded !font-bold"
      type="primary"
      @click="handleLogin"
      >登录</a-button
    >
  </div>
</template>
<style scoped>
.text-title {
  @apply whitespace-nowrap;
}
</style>
